interface IDefaultChunk {
  src: string;
  byteRange: {
    start: number;
    end: number;
  };
}

export interface IChunk extends IDefaultChunk {
  startTime: number;
  endTime: number;
  duration: number;
  index: number;
}

export interface IPlaylist {
  duration: number;
  metaChunk: IDefaultChunk;
  chunks: IChunk[];
}

export const parsePlaylist = (content: string) => {
  const playlist: IPlaylist = {
    duration: 0,
    metaChunk: {
      src: "",
      byteRange: {
        start: 0,
        end: 0,
      },
    },
    chunks: [],
  };

  const lines = content.split("\n");

  lines.forEach((line, index) => {
    if (line.startsWith("#EXT-X-MAP:URI")) {
      const result = /#EXT-X-MAP:URI="(.*)",BYTERANGE="(.*)@(.*)"/.exec(line);

      if (result === null) {
        return;
      }

      const [, src, length, start] = result;

      playlist.metaChunk = {
        src: src as string,
        byteRange: {
          start: Number(start),
          end: Number(start) + Number(length) - 1,
        },
      };

      return;
    }

    if (line.startsWith("#EXTINF")) {
      const chunkInfo = line.split(":")[1];
      const [duration] = chunkInfo.split(",");
      const byteRange = lines[index + 1].split(":")[1];
      const [length, start] = byteRange.split("@");
      const src = lines[index + 2];

      playlist.duration += Number(duration);

      const count = playlist.chunks.length;

      const startTime = count > 0 ? playlist.chunks[count - 1].endTime : 0;

      playlist.chunks.push({
        src,
        duration: Number(duration),
        startTime: Number(startTime),
        endTime: Number(startTime) + Number(duration),
        index: playlist.chunks.length,
        byteRange: {
          start: Number(start),
          end: Number(start) + Number(length) - 1,
        },
      });
    }
  });

  return playlist;
};
